import styled from 'styled-components'

export const ModalOverlay = styled.div`
  z-index: 1000;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 100%;
  min-width: 300px;
  max-width: 500px;
  min-height: 300px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModalContent = styled.div`
  width: 100%;
  a {
    color: #4183c4;
    text-decoration: none;
    background-color: transparent;
    font-size: 14px;
  }
`

export const ErrorMessage = styled.p`
  color: #e41c1c;
  margin: 0;
`
